/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Aside from './Aside';
import { withRouter } from 'react-router-dom';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import { getManagePermission } from '../helper';

const Wrapper = ({ children, history, match }) => {
  const permit = _.get(match, 'params.permit', '');
  const permissions = getJson('permissions');
  const canManage = Acl(permissions, [getManagePermission(permit)]);

  return (
    <div
      className="d-flex overflow-y-hidden"
      style={{ gap: '10px', minHeight: 0, overflowY: 'hidden' }}
    >
      {/* <div className="border rounded bg-white p-2 w-25">
        <Aside />
      </div> */}

      <div className="d-flex flex-column" style={{ minHeight: 0 }}>
        {canManage && (
          <button
            type="button"
            className="btn btn-sm bg-primary text-white mr-auto"
            style={{ marginBottom: '10px' }}
            onClick={() => {
              history.push(`/general-settings/templates/${permit}/create`);
            }}
          >
            Create Template
          </button>
        )}
        <div className="alert alert-primary" role="alert">
          <div className="d-flex align-items-center" style={{ gap: '20px' }}>
            <div className="fa fa-info" />
            FOR THE SELECTED/ACTIVE TEMPLATE: To use the default pre-defined
            template, click the Customize Template button then update the
            "Status" of the customized template and Save.
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};

Wrapper.propTypes = {
  children: PropTypes.instanceOf(Object),
  history: PropTypes.instanceOf(Object).isRequired,
};

Wrapper.defaultProps = {
  children: null,
};

export default withRouter(Wrapper);
